document.addEventListener('DOMContentLoaded', () => {
    iframeResize({
        license: "GPLv3"
    }, '.js-iframe-resizer');
});
